export function formatBaseTypeCheck(check) {
  switch (check.expected.length) {
    case 0:
      return "expected type: Never";
    case 1:
      return `expected type: ${check.expected[0]}`;
    default:
      return `expected type: ${check.expected.join(" | ")}`;
  }
}
